import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Filters } from '~/components/filters/Filters';
import { FiltersPanel } from '~/views/screener/filters-panel/FiltersPanel';
import {
  ScenarioPageModalType,
  useScenarioStore,
} from '~/widgets/scenario/hooks/use-scenario-store/useScenarioStore';

import * as S from './AssetSelectionFilters.styles';

export const AssetSelectionFilters = () => {
  const { t } = useTranslation('scenario');

  const { setActiveScenarioPageModal, filterGroups } = useScenarioStore(
    state => ({
      setActiveScenarioPageModal: state.setActiveScenarioPageModal,
      filterGroups: state.filterGroups,
    })
  );

  return (
    <FiltersPanel
      title={t('scenario:assetSelection')}
      data-testid="asset-selection-filters"
    >
      <S.HeaderWrapper>
        <S.FiltersWrapper>
          <Filters
            filterState={filterGroups.ASSET_FILTERS}
            store={useScenarioStore}
            group={'ASSET_FILTERS'}
            showCustomFilterModal={false}
            showAddMoreFilters={false}
          />
          <S.VerticalDivider />
          <Button
            variant="tertiary"
            size="small"
            label={t('scenario:filters.addMoreAssets')}
            iconPosition="right"
            iconName="Search"
            onClick={() =>
              setActiveScenarioPageModal(ScenarioPageModalType.addAssets)
            }
          />
        </S.FiltersWrapper>
      </S.HeaderWrapper>
    </FiltersPanel>
  );
};
